import React from "react"
import { Formik } from "formik"
import { Form } from "./Form"

const UpdateForm = ({ currentVersion, onSubmit, branch, onBranchChange }) => {
  const values = { file: "", currentVersion, newVersion: "", branch }
  return (
    <div
      style={{
        maxWidth: "300px",
      }}
    >
      <Formik
        render={(props) => <Form {...props} onBranchChange={onBranchChange} />}
        initialValues={values}
        enableReinitialize
        onSubmit={(values, { setSubmitting }) => {
          setTimeout(() => {
            onSubmit({
              file: values.file,
              version: values.newVersion,
              branch: values.branch,
            })
            setSubmitting(false)
          }, 400)
        }}
      />
    </div>
  )
}

export default UpdateForm
